import { Controller } from '@hotwired/stimulus'
import { connectUserData } from '../helpers/controllerHelpers/utils'
import type { CustomEvent, UserDataValue } from '../api/models/types'
/* NYI - Classes for switch - isOn, ToggleSwitch, ToggleSwitch .label */
export default class extends Controller {
  static classes = ['on']
  static targets = ['label']
  static values = {
    onLabel: String,
    offLabel: String,
    key: String,
  }

  declare readonly keyValue: string
  declare readonly onClass: string
  declare readonly hasOnClass: boolean
  disconnectUserData: (() => void) | undefined

  connect() {
    this.disconnectUserData = connectUserData(this, this.userDataValueChanged)
  }

  disconnect() {
    if (typeof this.disconnectUserData === 'function') this.disconnectUserData()
  }

  userDataValueChanged(newData: UserDataValue, oldData: UserDataValue) {
    const newUserDataValue = newData?.[this.keyValue]
    const oldUserDataValue = oldData?.[this.keyValue]
    if (newUserDataValue === oldUserDataValue) return

    this.setValue(!!newUserDataValue)
  }

  switchAccessibility(event) {
    if ((event as KeyboardEvent).key === ' ') event.preventDefault()
    if ((event as KeyboardEvent).key === 'Enter' || (event as KeyboardEvent).key === ' ') {
      this.toggle(event)
    }
  }

  toggle(event: CustomEvent) {
    const value = !(event.params && event.params.value)
    this.setValue(value)
    this.dispatch('update', { detail: { key: this.keyValue, value } })
  }

  setValue(value: boolean) {
    /* Value is what the value in user data currently is */
    this.element.setAttribute('data-switch-value-param', String(value))
    if (!this.hasOnClass) return
    value ? this.element.classList.add(this.onClass) : this.element.classList.remove(this.onClass)
  }
}
